import React from 'react'
import { useSelector } from 'react-redux'
import { Avatar, Box, List, Popover, Typography } from '@mui/material'
import AccountMenuItems from './AccountMenuItems'

const AccountMenuPopover = ({ anchorElement, onClose }) => {
  const {
    firstName,
    lastName,
    email,
    imageUrl,
  } = useSelector((state) => state.user?.details || {})
  const fullName = [firstName, lastName].filter(Boolean).join(' ')
  const avatarLabel = fullName || email || 'Account'

  return (
    <Popover
      anchorEl={anchorElement}
      onClose={onClose}
      open={Boolean(anchorElement)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{ sx: { maxWidth: 'calc(100vw - 32px)', width: 280 } }}
    >
      <Box
        aria-label="Signed-in account"
        sx={{
          alignItems: 'center',
          backgroundColor: 'grey.50',
          borderBottom: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          gap: 1.5,
          px: 2,
          py: 1.75,
        }}
      >
        <Avatar alt={avatarLabel} src={imageUrl || undefined} sx={{ height: 44, width: 44 }}>
          {avatarLabel.charAt(0).toUpperCase()}
        </Avatar>
        <Box sx={{ minWidth: 0 }}>
          <Typography fontWeight={600} noWrap title={fullName || 'Account'}>
            {fullName || 'Account'}
          </Typography>
          {email && (
            <Typography color="text.secondary" noWrap title={email} variant="body2">
              {email}
            </Typography>
          )}
        </Box>
      </Box>
      <List sx={{ '& .MuiListItemText-primary': { fontSize: 15 } }}>
        <AccountMenuItems onNavigate={onClose} />
      </List>
    </Popover>
  )
}

export default AccountMenuPopover
